var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "v-select-menu max-w-full" },
    [
      _c("v-select", {
        staticClass: "v-select-custom",
        class: {
          "v-select-custom--above": _vm.openAbove,
          "v-select-custom--themed": _vm.themed,
          "v-select-custom--small": _vm.small,
          "v-select-custom--large": _vm.large,
        },
        attrs: {
          id: _vm.id,
          placeholder: _vm.placeholder,
          options: _vm.options,
          searchable: false,
          clearable: false,
          filterable: false,
          required: _vm.required,
          "data-testid": _vm.testId,
          components: { OpenIndicator: _vm.OpenIndicator },
        },
        model: {
          value: _vm.selectOption,
          callback: function ($$v) {
            _vm.selectOption = $$v
          },
          expression: "selectOption",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }